import { UtilityCyclesPage } from '@/components/billing/utility-cycles-page'

export function AdminBillingUtilityCycles() {
  return <UtilityCyclesPage basePath="/admin/billing" />
}
